const config = {
	pageSize: 25,
	debounceLength: 250,
};

export default config;
